export const WHITESPACE_SPACE_TOKEN = "{whitespace.space}";
